// ABOUTME: Admin route wrappers that extract params for nested admin pages.
// ABOUTME: Provides proper workspaceId from URL params to child components.

import { useParams } from 'react-router-dom';
import { AgentConfigPanel } from './AgentConfigPanel';

export function AgentConfigPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <div>Workspace ID required</div>;
  return <AgentConfigPanel workspaceId={id} />;
}
